(function () {
    'use strict';

    angular.module('thankview.global')
        .controller('FooterController', ['$scope', '$window', '$timeout', '$document', function ($scope, $window, $timeout, $document) {
            $scope.init = function () {
                $scope.now = new Date();
                $scope.baseUrl = $window.config.baseUrl;

                if (config.params) {
                    if (config.params.business) {
                        var businessParams = config.params.business;

                        $scope.isWhiteLabel = businessParams.white_label;
                        $scope.tagImageSrc = businessParams.tag_image;
                        $scope.hidePoweredBy = businessParams.no_powered_by;
                    }

                    if (config.params.video_caption) {
                        $scope.captionSrc = config.params.video_caption;
                        $scope.isWhiteLabel = true;
                    }
                }

                angular.element($document[0].querySelector('.powered-by .thankview-link img')).on('click', function () {
                    if (typeof gtag === 'function') {
                        gtag('event', 'powered by logo', { clicked: true });
                    }
                });

                angular.element($window).bind('resize', function () {
                    $scope.resize();
                });

                $scope.ready();
            };

            $scope.ready = () => {
                if (!config.loaded) {
                    $timeout(function () {
                        $scope.ready();
                    }, 100);
                    return;
                }

                $scope.resize();
            };

            $scope.resize = function () {
                var parent = angular.element($document[0].querySelector('#site-footer'));

                parent.css({ top: 0, position: 'relative', bottom: '' });

                var scrollTop = $window.pageYOffset || $document[0].documentElement.scrollTop;
                var footerHeight = parent[0].offsetHeight;
                var footerTop = parent[0].getBoundingClientRect().top;
                var diff = $window.innerHeight - footerTop - footerHeight - scrollTop;

                if (diff > 0) {
                    parent.css({ top: 'auto', position: 'fixed', bottom: 0 });
                    $scope.footerFixed = true;
                } else {
                    $scope.footerFixed = false;
                }
            };

            $scope.init();
        }]);
}());
